import React from 'react';
import { motion } from 'framer-motion';

const Legal = ({ title }) => {
    return (
        <div className="legal-container container">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="legal-content glass-morphism"
            >
                <h1>{title}</h1>
                <p className="last-updated">Last Updated: February 2026</p>

                <section>
                    <h2>1. Introduction</h2>
                    <p>Welcome to Aadhar Infotech. We are committed to protecting your privacy and providing a secure environment for all our users.</p>
                </section>

                <section>
                    <h2>2. Use of Information</h2>
                    <p>The information we collect is used to provide and improve our services, communicate with you, and comply with legal obligations.</p>
                </section>

                <section>
                    <h2>3. Data Protection</h2>
                    <p>We implement industry-standard security measures to protect your data from unauthorized access or disclosure.</p>
                </section>
            </motion.div>

            <style>{`
        .legal-container {
          padding-top: 150px;
          padding-bottom: 100px;
          min-height: 80vh;
        }
        .legal-content {
          padding: 4rem;
          border-radius: 2rem;
        }
        .legal-content h1 {
          font-size: 3rem;
          margin-bottom: 1rem;
          background: linear-gradient(135deg, var(--primary), var(--secondary));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .last-updated {
          color: var(--text-muted);
          margin-bottom: 3rem;
          font-weight: 600;
        }
        .legal-content h2 {
          margin: 2.5rem 0 1rem;
          color: #fff;
        }
        .legal-content p {
          color: var(--text-muted);
          line-height: 1.8;
          font-size: 1.1rem;
        }
      `}</style>
        </div>
    );
};

export default Legal;
